import classnames from 'classnames';
import Image from 'next/image';
import React, { CSSProperties, FC } from 'react';
import { useSelector } from 'react-redux';

import I18n from '@wetransfer/transfer/modules/i18n';
import { channelSelector } from '@wetransfer/transfer/store/selector/channel';

import WallpaperPreviewFallbackSmall from './images/illustration-wt-page--small__fallback.png';
import WallpaperPreviewFallback from './images/illustration-wt-page__fallback.png';
import WallpaperPreviewTopBar from './images/wallpaper-preview-top-bar.svg';
import WallpaperPreviewTransferWindow from './images/wallpaper-preview-transfer-window.svg';

import './ProWallpaperPreview.scss';

interface ChannelWallpaper {
  id: string;
  sourceUrl: string;
  title: string;
  href: string;
  src: string;
  resizedSrcSmall: string;
  resizedSrcMedium: string;
  resizedSrcLarge: string;
  wallpaperType: string;
}

interface ProWallpaperPreviewProps {
  small?: boolean;
  croppedView?: boolean;
  classNames?: string;
  style?: CSSProperties;
  isSmallViewport: boolean;
}

const ProWallpaperPreview: FC<ProWallpaperPreviewProps> = ({
  small = false,
  croppedView = false,
  classNames,
  isSmallViewport,
  ...rest
}) => {
  const { wallpapers } = useSelector(channelSelector);
  const wallpaperSize = small ? 'Small' : 'Medium';

  const wallpaperProperty:
    | 'resizedSrcSmall'
    | 'resizedSrcMedium' = `resizedSrc${wallpaperSize}`;

  const wallpaperFallback = small
    ? WallpaperPreviewFallbackSmall
    : WallpaperPreviewFallback;
  const wallpaper: ChannelWallpaper = wallpapers[0] || null;

  const wallpaperUrl: string = wallpaper
    ? wallpaper[wallpaperProperty]
    : wallpaperFallback;
  const isVideoWallpaper: boolean = wallpaper?.wallpaperType === 'video';

  return (
    <div
      className={classnames('ProWallpaperPreview', classNames, {
        'ProWallpaperPreview--small': isSmallViewport,
      })}
      {...rest}
    >
      <div className="ProWallpaperPreview__top-bar">
        <img
          src={WallpaperPreviewTopBar}
          alt={I18n.t('page.advertise.guidelines.advert_static.title')}
        />
      </div>
      <div className="ProWallpaperPreview__container">
        <div className="ProWallpaperPreview__transfer-window">
          <img
            className={classnames({ cropped: croppedView })}
            src={WallpaperPreviewTransferWindow}
            alt={I18n.t('page.advertise.guidelines.advert_static.title')}
          />
        </div>
        <div className="ProWallpaperPreview__wallpaper">
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          {isVideoWallpaper && <video src={wallpaperUrl} />}
          {!isVideoWallpaper && wallpaperUrl !== undefined && (
            <Image
              src={wallpaperUrl}
              alt={I18n.t('page.advertise.guidelines.advert_static.title')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProWallpaperPreview;
